export default "__VITE_ASSET__C$Qyiweo__"